module.exports = __webpack_public_path__ + "static/images/user-fill.17a9ebc0dfdf5fd7f40a454adf549da7.svg";